import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApp } from '../context/AppContext';

//import resources
import Skeleton from 'react-loading-skeleton';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';
import ProductsComponent from '../components/dynamic/products/ProductsComponent' ;
import Categories from '../components/dynamic/products/Categories';
import Toolbar from '../components/dynamic/products/Toolbar';


//import locales
import { useTranslation } from "react-i18next";
import "../i18n";


//import api
import FetchData from "../api/Api";

export default function Products() {

    //get context
    const { categories } = useApp();

    //get locale
    const { t } = useTranslation();
    const { locale, slug } = useParams();

    //get data
    const [data, setData] = useState(null);
    const [grid, setGrid] = useState([4, 3, 6]);
    

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/products/${slug}`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            setTimeout(function() {
                fetchData();
            }, 100)

            
        }

    }, [data, locale, slug]);

    useEffect(()=> {
        setData(null);
    }, [locale, slug])



    return (
        <>
            <Breadcrumb title={t('products')} url="/products" subtitle={ data === null ? <Skeleton width={100} height={20} baseColor='#f2f2f2' highlightColor='#fff' />: data?.category?.translations?.[0]?.name } />
            <div className='container mx-auto mt-10 px-3'>
                <div className="grid grid-cols-12 gap-5">
                    <div className="col-span-12 lg:col-span-3 gap-5">
                        <Categories />
                    </div>
                    <div className="col-span-12 lg:col-span-9 gap-5 grid-cols-12">
                        
                        <div className="col-span-12 mb-5">
                            <Toolbar data={data} setGrid={setGrid} grid={grid} />
                        </div>
                        <div className="col-span-12 gap-3 lg:gap-5 grid-cols-12 grid">
                            <ProductsComponent grid={grid} sort="price_asc" data={data} />
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    );
}